import { render, staticRenderFns } from "./PaymentNotSuccessfull.vue?vue&type=template&id=b53aa188&scoped=true&"
import script from "./PaymentNotSuccessfull.vue?vue&type=script&lang=js&"
export * from "./PaymentNotSuccessfull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53aa188",
  null
  
)

export default component.exports